import { Invoice } from "./invoice-model";
import { OpeningSlot } from "./opening-slot-model";
import { PasscultureHistorique } from "./passculture-historique-model";
import { Prestation } from "./prestation-model";
import { Profile } from "./profile-model";
import { Reservation } from "./reservation-model";
import { Studio } from "./studio-model";

export class CustomTable {
  endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  get_array_data(data: Array<any>) {
    let array: Array<any> = [];

    switch (this.endpoint) {
      case "passculture-historiques": {
        data.forEach((item: any) => {
          array.push(PasscultureHistorique.attributeToJson(item));
        });
        break;
      }
      case "users": {
        data.forEach((item: any) => {
          array.push(item);
        });
        break;
      }
      case "profiles": {
        data.forEach((item: any) => {
          array.push(Profile.attributeToJson(item));
        });
        break;
      }
      case "studios": {
        data.forEach((item: any) => {
          array.push(Studio.attributeToJson(item));
        });
        break;
      }
      case "reservations": {
        data.forEach((item: any) => {
          array.push(Reservation.attributeToJson(item));
        });
        break;
      }
      case "invoices": {
        data.forEach((item: any) => {
          array.push(Invoice.attributeToJson(item));
        });
        break;
      }
      case "prestations": {
        data.forEach((item: any) => {
          array.push(Prestation.attributeToJson(item));
        });
        break;
      }
      case "opening-slots": {
        data.forEach((item: any) => {
          array.push(OpeningSlot.attributeToJson(item));
        });
        break;
      }
      default: {
        array = [];
        break;
      }
    }

    return array;
  }
}
